import { useQuery } from "@apollo/client";
import { Box, Image, Text } from "grommet";
import { useEffect } from "react";
import { GET_DENY_STATUS } from "../queries/user_queries";

type Props = {
  isWidget?: boolean;
};
const DenyStatus = ({ isWidget }: Props) => {
  // broadcasterName used to be sent from here, but the resolver never read
  // it - it's decided server-side now (see resolvers.ts's `broadcaster`).
  const { loading, error, data, startPolling, stopPolling } =
    useQuery(GET_DENY_STATUS);

  useEffect(() => {
    if (isWidget) {
      startPolling(1000);
    } else {
      startPolling(5000);
    }
    return () => stopPolling();
  }, []);
  let denyStatus;
  if (data) {
    denyStatus = data.getDenyStatus;
  } else {
    return <></>;
  }

  const { isDenied, deniedby, unDeniedby, numberOfDenies, numberOfUndenies } =
    denyStatus;
  const color = isDenied ? "status-critical" : "status-ok";
  const message = isDenied ? "Cum Denied :(" : "Cum Undenied ;)";
  const numberDifference = Math.abs(
    Math.floor(numberOfDenies) - Math.floor(numberOfUndenies),
  );
  const count = isDenied ? numberDifference : numberDifference + 1;
  const countColor = isDenied ? "status-ok" : "status-critical";
  const submessage = isDenied
    ? `Undeny Me for ${isWidget ? "669 tokens" : "600 ccs"} `
    : `Deny Me for ${isWidget ? "666 tokens" : "600 ccs"}`;

  let imageUrl = "";
  if (isDenied && count >= 3) {
    imageUrl = `https://media.discordapp.net/attachments/1455390059921670194/1462224124901331085/GIF_20251230_164031_588.gif?ex=696d69d6&is=696c1856&hm=7d2e7ae7f57d95450bc5c5f1b866cb0e8fe40b42fd72a91b17e974e02898ce32&=`;
  }
  if (!isDenied && count >= 3) {
    imageUrl = `https://media.discordapp.net/attachments/1455390059921670194/1462224124901331085/GIF_20251230_164031_588.gif?ex=696d69d6&is=696c1856&hm=7d2e7ae7f57d95450bc5c5f1b866cb0e8fe40b42fd72a91b17e974e02898ce32&=`;
  }
  return (
    <Box
      round
      background={color}
      animation={["fadeIn", { size: "small", type: "pulse" }]}
      margin="small"
      direction="row"
      align="center"
      justify="center"
      height={isWidget ? "144px" : "xsmall"}
    >
      <Box flex justify="center">
        <Box direction="row" align="center" justify="center" gap="xsmall">
          <Box flex>
            <Text color={"light-1"} textAlign="center" size="xxlarge">
              {message}
            </Text>
            <Box direction="row" justify="center" align="center">
              <Text textAlign="center" color="light-1" size="large">
                {submessage}
              </Text>
              <Text size="xxlarge" color={countColor} weight={"bolder"}>
                {`x ${count}`}
              </Text>
            </Box>
          </Box>
          {imageUrl ? (
            <Box height="xsmall" width="xsmall" round="large">
              <Image fit="cover" src={`/denystatus.gif`} />
            </Box>
          ) : (
            <></>
          )}
        </Box>
      </Box>
    </Box>
  );
};

export default DenyStatus;
